
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuthMode } from "@/hooks/auth/useAuthMode";
import { useEmailVerification } from "@/hooks/auth/useEmailVerification";
import { useAuthSubmission } from "@/hooks/auth/useAuthSubmission";

export const useAuthFlow = () => {
  const {
    isSignUp,
    setIsSignUp,
    signupDisabled,
    setSignupDisabled,
    handleToggleMode,
    resetAuthMode
  } = useAuthMode();

  const {
    isVerifying,
    setIsVerifying,
    pendingVerificationEmail,
    setPendingVerificationEmail,
    pendingCredentials,
    setPendingCredentials,
    handleVerifyCode: originalHandleVerifyCode,
    handleResendCode: originalHandleResendCode,
    resetVerification
  } = useEmailVerification();

  const location = useLocation();
  
  useEffect(() => {
    // Check for verification parameter in URL
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('verification') === 'true') {
      const storedEmail = localStorage.getItem('pendingVerificationEmail');
      if (storedEmail) {
        handleVerifyCode(storedEmail);
      }
    }
  }, [location]);

  // Create wrapper functions that match the expected return type in Auth.tsx
  const handleVerifyCode = async (verificationCode: string) => {
    await originalHandleVerifyCode(verificationCode);
  };

  const handleResendCode = async () => {
    await originalHandleResendCode();
  };

  const {
    isLoading,
    handleSubmit,
    from
  } = useAuthSubmission({
    isSignUp,
    setIsSignUp,
    setIsVerifying,
    setPendingVerificationEmail,
    setPendingCredentials,
    setSignupDisabled
  });

  const handleBackToLogin = () => {
    resetVerification();
    resetAuthMode();
  };

  return {
    // Auth mode state
    isSignUp,
    signupDisabled,
    
    // Loading state
    isLoading,
    
    // Verification state
    isVerifying,
    pendingVerificationEmail,
    
    // Handle functions
    handleSubmit,
    handleVerifyCode,
    handleResendCode,
    handleBackToLogin,
    handleToggleMode,
    
    // Navigation
    from
  };
};
